
import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 25px;
    right: 25px;
    background-color: #006560;
    color: white;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    z-index: 99998;
    width: 52px;
    height: 52px; 

    @media (min-width: 720px) {
        display: none;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
    }
`;

export const SvgIcon = styled(SVG)`
    width: 75%;
    height: 75%;
    align-self: center
`;

export const ExpandedContent = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    width: ${(props) => (props.$show ? '320px' : '0px')};
    height: ${(props) => (props.$show ? '350px' : '0px')};
    padding: ${(props) => (props.$show ? '5px' : '0px')};
    scale: ${(props) => (props.$show ? '1' : '0')};
    opacity: ${(props) => (props.$show ? 1 : 0)};
    position: fixed;
    bottom: 25px;
    right: 25px;
    background-color: #006560;
    color: white;
    border-radius: 5px;
    transition: 1s;
    z-index: 99999;
    @media (min-width: 720px) {
        display: none;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
    }
`;

export const SubitensContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    flex-wrap: wrap;
    // height: ${(props) => (props.$show ? '350px' : props.$notShow ? '0px' : '350px')};
    height: 350px;
    width: ${(props) => (props.$show ? '320px' : '0px')};
    padding: ${(props) => (props.$show ? '5px' : '0px')};
    // visibility: ${(props) => (props.$show ? 'visible' : 'hidden')};
    opacity: ${(props) => (props.$show ? 1 : 0)};
    position: fixed;
    right: 0.1px;
    background-color: #006560;
    color: white;
    border-radius: 5px;
    transform-origin: right;
    transition: 1s;
    z-index: 99999;
    @media (min-width: 720px) {
        display: none;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
    }
`;


export const ContainerCenter = styled(SVG)`
    position: relative; 
    width: 95px; 
    height: 95px;
`;

export const Indicator = styled.div`
    position: absolute;
    width: 0px;
    height: 0px;
    background-color: transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid #014642;
    transform: rotate(-90deg);
    top: 46%;
    left: 34%;
`;